// src/pages/Solicitacoes/components/statusColors.js
const statusColors = {
    Pendente: '#FACC15',
    Aprovado: '#34D399',
    Rejeitado: '#EF4444',
    Encerrado: '#6B7280',
};

export default statusColors;
